import FBtnMDP, { BtnType } from "@/components/FBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import * as Snackbar from "node-snackbar";
import FFormDrawerMDP from "@/components/form/FFormDrawerMDP";
import FCreditorAutoCompleteFieldMDP from "@/components/form/field/FCreditorAutoCompleteFieldMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FCreditCardFieldMDP from "@/components/form/field/FCreditCardFieldMDP";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";

export default class FAddCreditorFFormMDP extends FFormDrawerMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      myRefName: "addCreditorFormRef",
      disabled: taskRoot.taskDisabled,
      isVisible: parent.addCreditorDialog,
      onClose: () => this.parent.closeAndClearAllForms(),
      title:"Add Creditor"
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this
    // .addField(new FClCreditorSelectFieldMDP({
    //   dataSelectorKey: "clCreditorId",
    //   label: "Search Client Creditor(Optional)",
    //   parentMDP: this.childMDP,
    //   boundaryClass: "col-4",
    //   onSelect: this.handleClientCreditorChange()
    // }))
    .addField(
      new FCreditorAutoCompleteFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "creditorName",
        label: "Creditor",
        mandatory: true,
        boundaryClass: "col-6",
      })
    )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "creditorBalance",
          label: "Creditor Balance",
          mandatory: true,
          boundaryClass: "col-6",
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "emiAmount",
          label: "EMI Amount",
          mandatory: true,
          boundaryClass: "col-6",
        })
      )

      // .addField(
      //   new FCurrencyFieldMDP({
      //     parentMDP: this.childMDP,
      //     dataSelectorKey: "creditorAmountOverdue",
      //     label: "Overdue Amount",
      //     boundaryClass: "col-6",
      //     mandatory: true
      //   })
      // )

      
      
      .addField(
        new FSelectDateFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "lastDateOfPayment",
          label: "Last Date of Payment",
          mandatory: true,
          boundaryClass: "col-6",
          futureDaysDisabled: true,
        })
      )

      .addField(
        new FSelectFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "debtType",
          label: "Type of Debt",
          mandatory: true,
          boundaryClass: "col-6",
          options: [
            "Credit Card",
            "Personal Loans",
            "Others (Unsecured)",
          ],
        })
      )

      .addField(
        new FCreditCardFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Credit Card Number",
          mandatory: true,
          boundaryClass: "col-6",
          condition: this.parent.isCreditCard(),
          // rules: "min:9|max:20",
          rules: "min:4|max:20|no_space",
        })
      )

      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Account Number",
          mandatory: true,
          boundaryClass: "col-6",
          condition: !this.parent.isCreditCard(),
          // rules: "min:9|max:20",
          rules: "min:4|max:20|no_space",
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "details",
          label: "Details",
          boundaryClass: "col-6",
        })
      )

      // .addAction(
      //   new FBtnMDP({
      //     label: "Cancel",
      //     btnType: BtnType.TEXT,
      //     onClick: () => {
      //       this.parent.closeAndClearAllForms();
      //     },
      //   })
      // )
      .addAction(
        new FFormSubmitBtnMDP({
          label: "Add Creditor",
          onClick: () => this.addCreditor(),
        })
      );
  }

  getMyRef() {
    return this.parent.$refs[this.myRefName];
  }


  addCreditor() {
    const input = Data.ClientFile.AddFiCreditorInput.fromJson(
      this.parent.addCreditorForm
    );
    input.clientFileId = (
      this.taskRoot as any
    ).clientFileBasicInfo.clientFileId;
    // input.skipUnderwrittingRule = false;
    console.table(input)
      input.clientId =   (this.taskRoot as any
      ).clientFileBasicInfo.clientBasicInfo.clientId
    
    // input.taskId = this.taskRoot.taskId;
    Action.ClientFile.AddFiCreditor.execute(input, (output) => {
      this.parent.closeAndClearAllForms();
      Snackbar.show({
        text: "Succesfully saved",
        pos: "bottom-center",
      });
    });
  }

  handleClientCreditorChange() {
    return (item: any) => {
      this.parent.handleClientCreditorChange(item);
    }
  }
}
